const getFieldSummaryDetailsForOneOption = (field, option) => {
  const fieldSummary = {
    qty: 0,
    monthlyCharges: 0,
    oneTimeCharges: 0,
    threeYearEasyPaymentCharges: 0,
    fiveYearEasyPaymentCharges: 0
  };
  if (!field) return fieldSummary;
  if (option && field.value && field.value.includes(option)) {
    const valueInOptions = field.options.find(
      optionItem => optionItem.fields.value === option
    );
    if (valueInOptions) {
      fieldSummary.qty = 1;
      const selectedValue = valueInOptions.fields;
      fieldSummary.monthlyCharges = selectedValue.monthlyPayment;
      fieldSummary.oneTimeCharges = selectedValue.oneTimePrice || 0;
      fieldSummary.threeYearEasyPaymentCharges =
        selectedValue.threeYearEasyPayment || 0;
      fieldSummary.fiveYearEasyPaymentCharges =
        selectedValue.fiveYearEasyPayment || 0;
    }
  }
  return fieldSummary;
};

export const getSummaryDetailsForFieldWithSelectedOptions = field => {
  const summary = [];

  if (!field || !field.type) return summary;

  switch (field.type) {
    case 'MultiCheckbox':
      (field.value || []).forEach(fieldItem => {
        const valueInOptions = field.options.find(
          optionItem => optionItem.fields.value === fieldItem
        );
        if (valueInOptions) {
          const selectedValue = valueInOptions.fields;
          summary.push({
            description: fieldItem,
            oneTimeCharges: selectedValue.oneTimePrice || 0,
            monthlyCharges: selectedValue.monthlyPayment || 0,
            threeYearEasyPaymentCharges:
              selectedValue.threeYearEasyPayment || 0,
            fiveYearEasyPaymentCharges: selectedValue.fiveYearEasyPayment || 0
          });
        }
      });
      break;

    default:
      break;
  }
  return summary;
};

export const getFieldSummaryDetailsFromField = field => {
  const summary = {
    qty: '',
    description: '',
    monthlyCharges: 0,
    oneTimeCharges: 0,
    threeYearEasyPaymentCharges: 0,
    fiveYearEasyPaymentCharges: 0
  };

  if (!field) return summary;
  switch (field.type) {
    case 'Radio':
      if (!field.value) return summary;
      // eslint-disable-next-line no-case-declarations
      const selectedOption = field.options.find(
        option => option.fields.value === field.value
      );
      if (selectedOption) {
        summary.qty = '1';
        summary.description = selectedOption.fields.label;
        summary.monthlyCharges += selectedOption.fields.monthlyPayment || 0;
        summary.oneTimeCharges += selectedOption.fields.oneTimePrice || 0;
        summary.threeYearEasyPaymentCharges +=
          selectedOption.fields.threeYearEasyPayment || 0;
        summary.fiveYearEasyPaymentCharges +=
          selectedOption.fields.fiveYearEasyPayment || 0;
      }
      break;
    case 'PlusMinusInput':
      summary.qty = field.value;
      summary.description = '';
      summary.monthlyCharges += field.monthlyPayment * +field.value || 0;
      summary.oneTimeCharges += field.oneTimePrice * +field.value || 0;
      summary.threeYearEasyPaymentCharges +=
        field.threeYearEasyPayment * +field.value || 0;
      summary.fiveYearEasyPaymentCharges +=
        field.fiveYearEasyPayment * +field.value || 0;
      summary.unitPrice =
        field.oneTimePrice ||
        field.monthlyPayment ||
        field.threeYearEasyPayment ||
        field.fiveYearEasyPayment;
      break;

    case 'Number':
      summary.qty = '';
      summary.description = '';
      summary.monthlyCharges += (field.monthlyPayment || 0) * +field.value || 0;
      summary.oneTimeCharges += (field.oneTimePrice || 0) * +field.value || 0;
      summary.threeYearEasyPaymentCharges +=
        (field.threeYearEasyPayment || 0) * +field.value || 0;
      summary.fiveYearEasyPaymentCharges +=
        (field.fiveYearEasyPayment || 0) * +field.value || 0;
      break;

    default:
      break;
  }
  return summary;
};

export default getFieldSummaryDetailsForOneOption;
